import type { IconType } from 'react-icons';
import {
  FiFolder,
  FiHeart,
  FiBook,
  FiCreditCard,
  FiShield,
  FiActivity,
  FiDollarSign,
} from 'react-icons/fi';

export const ALL_VAULT_CATEGORY_FILTER = 'All' as const;

export const VAULT_CATEGORIES = [
  { key: 'Medical', label: 'Medical', icon: FiHeart },
  { key: 'School', label: 'School', icon: FiBook },
  { key: 'Identity', label: 'Identity', icon: FiCreditCard },
  { key: 'Legal', label: 'Legal', icon: FiShield },
  { key: 'Financial', label: 'Financial', icon: FiDollarSign },
  { key: 'Activities', label: 'Activities', icon: FiActivity },
  { key: 'Other', label: 'Other', icon: FiFolder },
] as const;

export type VaultCategory = (typeof VAULT_CATEGORIES)[number]['key'];
export type VaultCategoryFilter = typeof ALL_VAULT_CATEGORY_FILTER | VaultCategory;

const DEFAULT_CATEGORY = VAULT_CATEGORIES[VAULT_CATEGORIES.length - 1];

export function getVaultCategoryDefinition(category: string | null | undefined) {
  if (!category) {
    return DEFAULT_CATEGORY;
  }
  return VAULT_CATEGORIES.find((item) => item.key === category) ?? DEFAULT_CATEGORY;
}

export function guessCategory(fileName: string, mimeType: string): VaultCategory {
  const content = `${fileName} ${mimeType}`.toLowerCase();

  if (
    content.includes('insurance') ||
    content.includes('medical') ||
    content.includes('vaccine') ||
    content.includes('immunization') ||
    content.includes('prescription')
  ) {
    return 'Medical';
  }

  if (
    content.includes('school') ||
    content.includes('report card') ||
    content.includes('permission slip') ||
    content.includes('iep')
  ) {
    return 'School';
  }

  if (
    content.includes('passport') ||
    content.includes('license') ||
    content.includes('birth certificate') ||
    content.includes('ssn') ||
    content.includes('identity') ||
    content.includes('id card')
  ) {
    return 'Identity';
  }

  if (
    content.includes('court') ||
    content.includes('custody') ||
    content.includes('legal') ||
    content.includes('mediation')
  ) {
    return 'Legal';
  }

  if (
    content.includes('support') ||
    content.includes('reimbursement') ||
    content.includes('invoice') ||
    content.includes('financial')
  ) {
    return 'Financial';
  }

  if (
    content.includes('camp') ||
    content.includes('sports') ||
    content.includes('travel') ||
    content.includes('activity')
  ) {
    return 'Activities';
  }

  return 'Other';
}

export type VaultCategoryDef = {
  key: VaultCategory;
  label: string;
  icon: IconType;
};
